import { render, staticRenderFns } from "./nota-validada.vue?vue&type=template&id=4b2bbc91&"
import script from "./nota-validada.vue?vue&type=script&lang=js&"
export * from "./nota-validada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports